import styled from 'styled-components'

export const WidgetFixedHeader = styled.div<{ isArticleWidget?: boolean }>`
    background-color: ${p => p.theme.headerBackgroundColor};
    top: 0px;
    padding-top: 15px;
    position: sticky;
    ${p => (p.isArticleWidget ? 'border-radius: 15px; overflow: hidden;' : '')};
`
